import fileSize from 'filesize';

const formatter = fileSize.partial({
  base: 10,
  round: 0,
});

export const displayFileSize = (bytes: number) =>
  formatter(bytes).toUpperCase();
